/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetToolResult } from '../../models/get-tool-result';

export interface GetnotificationsToolUpdatedSchema$Params {
}

export function getnotificationsToolUpdatedSchema(http: HttpClient, rootUrl: string, params?: GetnotificationsToolUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<GetToolResult>> {
  const rb = new RequestBuilder(rootUrl, getnotificationsToolUpdatedSchema.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetToolResult>;
    })
  );
}

getnotificationsToolUpdatedSchema.PATH = '/api/hubs/notifications/ToolUpdated';
